export const MANAGE_OFFICES_PATH = '/home/manage-offices';
